module.exports = __webpack_public_path__ + "img/wz-5-2.834b6e84.png";